import { IResState, IConfirmState } from '@/store/types';

// 字典管理
export interface IModuleState {
  mainList: IList;
  stopList: IList;
  synonymList: IList;
  schList: IQueryList;
  docList: IQueryList;
  checkList: ICheckedList;
  dialog: IDialog;
  confirm: IConfirm;
  loading: boolean;
}

export type IList = IResState<IListRecord[]>;
export type IQueryList = IResState<string[]>;
export type IConfirm = IConfirmState<IActiveRecord>;

export interface IActions {
  queryDicts(params: IListParams): void;
  queryDictSch(params: IQueryParams): void;
  queryDictDoc(params: IQueryParams): void;
  checkDict(params: ICheckParams): void;

  exportDict(params: IExportParams): void;
  importDict(params: IImportParams): void;

  addDictMain(params: IAddMainParams): void;
  addDictSynonym(params: IAddSynonymParams): void;
  editDictSynonym(params: IEditSynonymParams): void;
  deleteDictMain(params: IDeleteMainPrams): void;
  deleteDictSynonym(params: IDeleteSynonymPrams): void;

  setDictSynonymList(params: Partial<IList>): void;
  setDictSchList(params: Partial<IQueryList>): void;
  setDictDocList(params: Partial<IQueryList>): void;
  setDictCheckList(params: Partial<ICheckedList>): void;
  setDialog(params: Partial<IDialog>): void;
  setConfirm(params: Partial<IConfirm>): void;
}

// 字典类型枚举
export enum Type {
  Main = 1, // 主词典
  Stop = 2, // 停止词
  Synonym = 3,  // 同义词
}

// 同义词添加或编辑弹窗
export interface IDialog {
  title: string;
  action: string;
  loading: boolean;
  visible: boolean;
  active?: IActiveRecord;
}

export interface ICheckedList {
  data: IListRecord[];
  loading: boolean;
  success: boolean;
}

// 列表 record
export interface IListRecord {
  source: string[];
  target: string[] | null;
}

// 弹窗 active record
export interface IActiveRecord {
  index: number;
  source: string[];
  target: string[];
}

// 接口参数 - 查询列表
export interface IListParams {
  type: Type.Main | Type.Stop | Type.Synonym;
}

// 接口参数 - 查询文档分词或搜索分词
interface IQueryParams {
  text: string;
}

// 接口参数 - 检查词语(主要用来检查同义词)
interface ICheckParams {
  type: Type.Main | Type.Stop | Type.Synonym;
  selectDict: { target: string[]; };
}

// 接口参数 - 添加主词典或停止词
interface IAddMainParams {
  type: Type.Main | Type.Stop;
  addDict: { source: string[]; };
}

// 接口参数 - 添加同义词
interface IAddSynonymParams {
  type: Type.Synonym;
  addDict: { source: string[], target: string[]; };
}

// 接口参数 - 编辑同义词
interface IEditSynonymParams {
  index: number;  // 接口不需要这个入参, 前端逻辑需要用到
  type: Type.Synonym;
  addDict: { source: string[], target: string[]; };
}

// 接口参数 - 删除主词典或停止词
interface IDeleteMainPrams {
  type: Type.Main | Type.Stop;
  deleteDict: { source: string[]; };
}

// 接口参数 - 删除同义词
interface IDeleteSynonymPrams {
  type: Type.Synonym;
  deleteDict: { target: string[]; };
}

// 接口参数 - 导出字典
interface IExportParams {
  type: Type.Main | Type.Stop | Type.Synonym;
}

// 接口参数 - 导入字典
interface IImportParams {
  type: Type.Main | Type.Stop | Type.Synonym;
  file: File;
}
